import DetailsPageTitle from "components/common/DetailsPageTitle";
import Spinners from "components/common/Spinners";
// import {
//   formatDate,
//   formatPlanType,
//   getRelativeTimeFromNow,
//   setPageTitle,
// } from "components/common/utils";
import React, { useEffect } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { showAlert } from "store/reducers/alertReducer";
// import PriceCurrency from "components/common/PriceCurrency";
import { subscriptionsStatus } from "components/constants/StatusKeys";
import { getSubscriptionDetails } from "store/actions/subscriptionsSlice";
import {
  CurrencySymbol,
  formatDate,
  formatPlanType,
  getRelativeTimeFromNow,
} from "components/common/Utils";
const SubscriptionDetails = () => {
  const { t } = useTranslation();

  // setPageTitle("Subscription Details", t);
  document.title = t("Subscription Details | Work space");

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const { loading, isLoading, subscriptionDetails } = useSelector(
    (state) => state.Subscriptions
  );

  useEffect(() => {
    dispatch(getSubscriptionDetails({ id }));
  }, []);

  const handleInvoiceDownload = (id) => {
    const payload = {
      id,
    };
    // dispatch(downloadSubscriptionInvoice(payload))
    //   .then((action) => {
    //     const { statusCode, success, message, data } = action?.payload || {};
    //     if (statusCode === 200 && success) {
    //       dispatch(showAlert({ text: message, type: "success" }));
    //       data && window.open(data, "_blank", "noopener,noreferrer");
    //     } else {
    //       dispatch(showAlert({ text: message, type: "error" }));
    //     }
    //   })
    //   .catch((err) => {});
  };

  return (
    <React.Fragment>
      <div className="page-content common_details_page">
        {loading ? (
          <Spinners />
        ) : (
          <Container fluid>
            <Row>
              <DetailsPageTitle title="Subscription Details" />
            </Row>
            <div className="common_wrapper">
              <Row>
                <Col lg={12}>
                  <div className="common_table_style">
                    <Table>
                      <thead className="t_head">
                        <tr>
                          <th>Date </th>
                          <th>Status</th>
                          <th>Subscription ID</th>
                          {/* <th>User</th>
                          <th>Number</th>
                          <th>Plan Type</th> */}
                          {/* <th>Screen Licenses</th> */}
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Next Billing Date</th>
                          {/* <th>Coupon</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <p className="w_fit_content">
                              {getRelativeTimeFromNow(
                                subscriptionDetails?.createdAt
                              )}
                            </p>
                          </td>
                          <td>
                            {
                              <p
                                className={`subscriptions_status ${
                                  subscriptionsStatus?.find(
                                    (option) =>
                                      option.value ===
                                      subscriptionDetails?.status
                                  )?.className
                                }`}
                              >
                                {
                                  subscriptionsStatus?.find(
                                    (option) =>
                                      option.value ===
                                      subscriptionDetails?.status
                                  )?.name
                                }
                              </p>
                            }
                          </td>
                          <td>{subscriptionDetails?.subscriptionNumber}</td>
                          {/* <td>{subscriptionDetails?.subscriptionNumber}</td>
                          <td>{subscriptionDetails?.userId?.name || "-"}</td>
                          <td>
                            <div className="w_fit_content">
                              {subscriptionDetails?.userId?.phone}{" "}
                            </div>
                          </td> */}
                          {/* <td>
                            {formatPlanType(
                              subscriptionDetails?.subscriptionType
                            )}
                          </td> */}
                          {/* <td>{subscriptionDetails?.screenCount}</td> */}
                          <td>
                            {formatDate(
                              subscriptionDetails?.billingCycleStart,
                              "dd MMM, yyyy"
                            )}
                          </td>
                          <td>
                            {formatDate(
                              subscriptionDetails?.billingCycleEnd,
                              "dd MMM, yyyy"
                            )}
                          </td>
                          <td>
                            {formatDate(
                              subscriptionDetails?.nextBillingDate,
                              "dd MMM, yyyy"
                            )}
                          </td>
                          {/* <td>
                            <Link to={"#"} className="dark_light_blue">
                              {subscriptionDetails?.coupon}
                            </Link>
                          </td> */}
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="common_card">
                    <h2 className="fs_20">{t("Price Details")}</h2>
                    <div className="g_between mt_18 gap-3">
                      <h2 className="fs_14 text_6f">{t("Sub Total")}</h2>
                      <h2 className="fs_14 text_6f">
                        <CurrencySymbol width="12" height="12" />
                        {subscriptionDetails?.price}{" "}
                      </h2>
                    </div>
                    {/* <div className="g_between mt_18 gap-3">
                      <h2 className="fs_14 text_6f">
                        {t(
                          `VAT ${
                            subscriptionDetails?.lastInvoiceInfo?.transactionId
                              ?.splitPayments?.vatValue
                              ? `(${subscriptionDetails?.lastInvoiceInfo?.transactionId?.splitPayments?.vatValue})`
                              : ""
                          }`
                        )}
                        <span className="fs_12 mx-2">{t("(Included)")}</span>
                      </h2>
                      <h2 className="fs_14 text_6f">
                        {
                          subscriptionDetails?.lastInvoiceInfo?.transactionId
                            ?.splitPayments?.vatAmount
                        }{" "}
                      </h2>
                    </div>

                    <div className="g_between mt_18 gap-3">
                      <h2 className="fs_14 text_6f">
                        {t("Discounted Amount")}
                      </h2>
                      <h2 className="fs_14 text_6f">
                        {
                          subscriptionDetails?.lastInvoiceInfo?.transactionId
                            ?.splitPayments?.discountedAmount
                        }{" "}
                      </h2>
                    </div> */}

                    <div className="g_between mt_18 total_amount_div">
                      <h2 className="fs_14">{t("Total")}</h2>
                      <h2 className="fs_14">
                        {/* <PriceCurrency
                          width="11"
                          height="12"
                          color={"#384459"}
                          currency={subscriptionDetails?.currency}
                        /> */}
                        <CurrencySymbol width="12" height="12" />
                        {subscriptionDetails?.lastPaidAmount}{" "}
                      </h2>
                    </div>

                    {subscriptionDetails?.lastInvoiceInfo?.transactionId
                      ?.invoiceUrl && (
                      <div className="mt_22">
                        <button
                          className="main_btn"
                          onClick={() => {
                            const url =
                              subscriptionDetails?.lastInvoiceInfo
                                ?.transactionId?.invoiceUrl;
                            if (url) {
                              window.open(url, "_blank");
                            } else {
                              console.log("Invoice URL not found");
                            }
                          }}
                        >
                          {t("Invoice")}
                        </button>
                      </div>
                    )}
                    {!subscriptionDetails?.lastInvoiceInfo?.transactionId
                      ?.invoiceUrl &&
                      subscriptionDetails?.lastInvoiceInfo?.transactionId
                        ?._id && (
                        <div className="mt_22">
                          <button
                            className="main_btn"
                            onClick={() => {
                              handleInvoiceDownload(
                                subscriptionDetails?.lastInvoiceInfo
                                  ?.transactionId?._id
                              );
                            }}
                            disabled={isLoading}
                          >
                            {t("Invoice")}
                          </button>
                        </div>
                      )}
                  </div>
                </Col>
                <Col lg={6}>
                  <Col lg={12}>
                    <div className="common_card orgnisation_details">
                      <div className="owner_orgnisation">
                        <h2 className="fs_20 user_heading">
                          {t("Organisation Details")}
                        </h2>
                        <h2 className="fs_12 text_dark_gray mt_22">
                          {t("Name")}
                        </h2>
                        <h2 className="fs_20 text_black">
                          {subscriptionDetails?.organizationId?.name || "-"}
                        </h2>
                        <h2 className="fs_12 text_dark_gray mt_18 ">
                          {t("Company Name")}
                        </h2>
                        <h2 className="fs_20 text_black">
                          {subscriptionDetails?.organizationId?.companyDetails
                            ?.companyName || "-"}
                        </h2>
                        <div className="mt_22 additional_details">
                          <h3 className="fs_12 text_dark_gray">{t("Email")}</h3>
                          <h3 className="fs_14 text_6f">
                            {subscriptionDetails?.organizationId?.email || "-"}
                          </h3>
                          <h3 className="fs_12 text_dark_gray">
                            {t("VAT Number")}
                          </h3>
                          <h3 className="fs_14 text_6f">
                            {subscriptionDetails?.organizationId?.companyDetails
                              ?.vatNumber || "-"}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className="my_plan_page mt_20">
                      <div className="common_card mt-0">
                        <div>
                          <div className="plan_div">
                            <div className="box"></div>
                            <div>
                              <h2 className="fs_12 text_dark_gray">
                                {t("Plan")}
                              </h2>
                              <h2 className="fs_20 text_black text-capitalize">
                                {t(
                                  formatPlanType(
                                    subscriptionDetails?.planId?.name
                                  )
                                )}
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="plan_details">
                          <div className="single_details">
                            <h2 className="fs_12 text_dark_gray">
                              {t("Due On")}
                            </h2>
                            <h2 className="fs_14 text_black_3">
                              {formatDate(
                                subscriptionDetails?.nextBillingDate,
                                "dd MMM yyyy"
                              )}
                            </h2>
                          </div>
                          <div className="single_details">
                            <h2 className="fs_12 text_dark_gray">
                              {t("Charged")}
                            </h2>
                            <h2 className="fs_14 text_black_3">
                              {subscriptionDetails?.isTrial
                                ? t("Free Trial")
                                : t(
                                    formatPlanType(
                                      subscriptionDetails?.subscriptionType
                                    )
                                  )}
                            </h2>
                          </div>
                          <div className="single_details">
                            <h2 className="fs_12 text_dark_gray">
                              {t("Locations")}
                            </h2>
                            <h2 className="fs_14 text_black_3">
                              {subscriptionDetails?.features?.locations}
                            </h2>
                          </div>
                          <div className="single_details">
                            <h2 className="fs_12 text_dark_gray">
                              {t("Members")}
                            </h2>
                            <h2 className="fs_14 text_black_3">
                              {subscriptionDetails?.features?.members}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Col>
              </Row>
            </div>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
};

export default SubscriptionDetails;
